import { ReactNode } from 'react';

export const GlassCard = ({ children, className }: { children: ReactNode, className?: string }) => {
    return (
        <div className={`
      relative overflow-hidden
      bg-bg-surface/30        /* Semi-transparent dark background (mapped to Tailwind config) */
      backdrop-blur-md     /* The "frosted" glass effect */
      border border-white/10 /* Subtle, premium border */
      shadow-[0_8px_32px_0_rgba(0,0,0,0.37)] /* Deep shadow for elevation */
      rounded-2xl
      ${className}
    `}>
            {/* Optional: A subtle noise texture overlay for grit */}
            <div className="absolute inset-0 opacity-[0.03] bg-[url('/noise.svg')] pointer-events-none" />

            <div className="relative z-10">
                {children}
            </div>
        </div>
    );
};
